// extracted by mini-css-extract-plugin
export default {"headerCell":"VirtualTableHeaderCell-headerCell-oq_lz","sortIcon":"VirtualTableHeaderCell-sortIcon-IdM2s"};